import React from "react";
import "../styles/InnerPageHeader.css";

export default function InnerPageHeader({ title, subtitle }) {
  return (
    <div className="iph">

<div className="iph__inner">
        <a href="/#homepage" className="iph__brand">
          <img src="./logo.jpeg" alt="Connect Moon" className="iph__logo" />
          <img src="./logoimg.jpeg" alt="Connect Moon" className="iph__wordmark" />
        </a>

        {title && (
          <div className="iph__text">
            <h1 className="iph__title">{title}</h1>
            {subtitle && <p className="iph__subtitle">{subtitle}</p>}
          </div>
        )}
      </div>
    </div>
  );
}
